import {NgModule} from "@angular/core";
import {OneDriveFilvelgerGui, OneDriveFilvelgerGuiAvhengigheter} from "./modale/onedrive-filvelger-dialog/OneDriveFilvelgerGui";
import {OneDriveOpplasting, OneDriveOpplastingAvhengigheter} from "./modale/onedrive-filvelger-dialog/OneDriveOpplasting";
import {GoogleLogin} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/googledrive-filvelger-dialog/GoogleLogin";
import {GoogleDriveFilvelgerGui, GoogleDriveFilvelgerGuiAvhengigheter} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/googledrive-filvelger-dialog/GoogleDriveFilvelgerGui";
import {GoogleDriveOpplasting, GoogleDriveOpplastingAvhengigheter} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/googledrive-filvelger-dialog/GoogleDriveOpplasting";

/** Modul som setter opp OneDrive/Google Drive spesifikke tjenester.
 * Definert i egen modul da jeg ikke finner noen annen naturlig modul å definere disse i. */
@NgModule({
    providers: [
        OneDriveFilvelgerGui,
        OneDriveOpplasting,
        OneDriveOpplastingAvhengigheter,
        GoogleDriveFilvelgerGui,
        OneDriveFilvelgerGuiAvhengigheter,

        GoogleDriveFilvelgerGuiAvhengigheter,
        GoogleDriveOpplasting,
        GoogleDriveOpplastingAvhengigheter,
        GoogleLogin
    ]
})
export class FilvelgerSkytjenesterModul {
}
